"use client"

import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/Components/ui/tooltip"

interface TrafficLightProps {
    TrafficLightColour: 4 | 2 | 1; // restrict to values 4, 2, 1
    Size?: number;
    Animate?: boolean;
    id?: string;
}

// 4 = green, 2 = amber, 1 = red
function TrafficLightComponent({ TrafficLightColour, Size = 8, Animate = true, id }: TrafficLightProps) {
    let colour = "bg-chart-green";
    let message = "Low Risk";
    const sizeStr = `h-${Size} w-${Size}`;

    const animateStr = Animate ? "animate-appear" : "";

    if (TrafficLightColour === 2) {
        colour = "bg-chart-amber";
        message = "Medium Risk";
    } else if (TrafficLightColour === 1) {
        colour = "bg-chart-red";
        message = "High Risk";
    }


    return (
        <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
            <div 
              id={id}
              className={`${sizeStr} rounded-full ${colour} ${animateStr} mx-auto transition-all duration-300 hover:shadow-[0_0_10px_5px_rgba(255,255,255,0.5)] hover:brightness-110`}
            />
        </TooltipTrigger>
        <TooltipContent className="flex flex-col bg-background">
            <div className="flex flex-row text-muted-foreground place-content-between">
                        <span className="pr-4">Status: </span><span className="bold text-foreground">{message}</span>
            </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
            
  );
}

export default TrafficLightComponent;